import { SubscriberBackendCredentials } from "../interfaces/SubscriberBackendCredentials";
import { SubscriberBackendBimerCredentialsModel } from "../models/SubscriberBackendBimerCredentialsModel";
import { SubscriberBackendInterfacenetCredentialsModel } from "../models/SubscriberBackendInterfacenetCredentialsModel";
import { SubscriberBackendShopCredentialsModel } from "../models/SubscriberBackendShopCredentialsModel";
import { SubscriberModel } from "../models/SubscriberModel";

export class SubscriberBackendCredentialsFactory {
	static build(credentials: SubscriberBackendCredentials, subscriber: SubscriberModel):any {
		if (subscriber.isBackendBimer()) {
			return new SubscriberBackendBimerCredentialsModel(credentials);
		} else if (subscriber.isBackendInterfacenet()) {
			return new SubscriberBackendInterfacenetCredentialsModel(credentials);
		} else if (subscriber.isBackendShop()) {
			return new SubscriberBackendShopCredentialsModel(credentials);
		}

		return null;
	}
}
